import { Collection } from '@nozbe/watermelondb';

import {
    InventoryProductModel,
    InventoryProductPayload,
} from '../../../../types/InventoryProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import {
    InventoryChangeModel,
    InventoryChangePayload,
} from '../../../../types/InventoryChange';
import { Database } from '@nozbe/watermelondb';

export const prepareCreateInventoryProduct = ({
    payload,
    userId,
    organisationID,
    collection,
}: {
    payload: InventoryProductPayload;
    userId: string;
    organisationID: string;
    collection: Collection<InventoryProductModel>;
}) =>
    collection.prepareCreate((inventoryProduct) => {
        inventoryProduct.productId = payload.productId;
        inventoryProduct.quantity = payload.quantity;
        inventoryProduct.favourite = payload.favourite;
        inventoryProduct.userId = userId;
        inventoryProduct.organisationId = organisationID;
    });

export const prepareCreateInventoryChange = ({
    payload,
    inventoryProduct,
    userId,
    organisationID,
    database,
}: {
    payload?: Omit<InventoryChangePayload, 'inventoryProductId'>;
    inventoryProduct: InventoryProductModel;
    userId: string;
    organisationID: string;
    database: Database;
}): InventoryChangeModel | undefined => {
    if (!payload) return undefined;

    return database.collections
        .get<InventoryChangeModel>('inventory_changes')
        .prepareCreate((inventoryChange) => {
            inventoryChange.inventoryProductId = inventoryProduct.id;
            inventoryChange.quantityChange = payload.quantityChange;
            inventoryChange.processAt = payload.processAt;
            inventoryChange.userId = userId;
            inventoryChange.organisationId = organisationID;
        });
};

export const logAddInventoryProductAction = ({
    inventoryProduct,
    logDBAction,
    tableName,
}: {
    inventoryProduct: InventoryProductModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create inventory product',
        modelName: tableName,
        payload: inventoryProduct,
    });
};

export const logAddInventoryChangeAction = ({
    inventoryChange,
    logDBAction,
}: {
    inventoryChange: InventoryChangeModel;
    logDBAction: DBWriterLoggerFunction;
}) =>
    logDBAction({
        message: 'Create inventory change',
        modelName: 'inventory_changes',
        payload: inventoryChange,
    });
